var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1197"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1197"
    },
    "bundlingPackage": "LearningCenterUI",
    "bundlingPackageVersion": "static-1.33962",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};